var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUploadIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42188 12.0361V14.8022C3.42188 15.2214 3.57991 15.6234 3.86121 15.9199C4.14252 16.2163 4.52405 16.3828 4.92188 16.3828H13.9219C14.3197 16.3828 14.7012 16.2163 14.9825 15.9199C15.2638 15.6234 15.4219 15.2214 15.4219 14.8022V12.0361M9.42243 11.8397L9.42243 2.88281M9.42243 2.88281L5.99386 6.3052M9.42243 2.88281L12.851 6.3052",
    stroke: "white",
    strokeWidth: 1.5166,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUploadIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UploadIcon.b6d7ef56.svg";
export { ForwardRef as ReactComponent };